

export interface PackingMaterialsLineItemT {
    item: string
    label: string
    quantity: number
    rate: number
    amount: number
    isDirty?: boolean
}
export const PackingMaterialsValueObj: PackingMaterialsLineItemT = {
    item: null,
    label: null,
    quantity: null,
    rate: null,
    amount: null,
    isDirty: null
}